import React from 'react'
import { Outlet } from 'react-router-dom'

import { StatusChecksSearchProvider } from 'components/status-checks/StatusChecksSearchState'
import { ObservabilityToolAuthenticationProvider } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { StatusCheckExternalIntegrationsProvider } from 'context/status-checks/StatusCheckExternalIntegrationsContext'

export const StatusChecksIndexRoutesWrapper: React.FC = () => {
  return (
    <StatusChecksSearchProvider>
      <StatusCheckExternalIntegrationsProvider>
        <ObservabilityToolAuthenticationProvider>
          <Outlet />
        </ObservabilityToolAuthenticationProvider>
      </StatusCheckExternalIntegrationsProvider>
    </StatusChecksSearchProvider>
  )
}
